import { countryName } from "@/lib/media";
import type { CitySuggestion } from "@/lib/types";

/**
 * Region part of a city path, localized: "Istanbul, Türkiye" for en,
 * "Bavaria, Almanya" for tr (admin1 may be missing; it passes through as
 * stored in GeoNames).
 */
export function cityRegion(city: CitySuggestion, locale: string): string {
  return [city.admin1Name, countryName(city.countryCode, locale)]
    .filter(Boolean)
    .join(", ");
}

/** Full display path for a city, localized: "İstinye, Istanbul, Türkiye". */
export function formatCityPath(city: CitySuggestion, locale: string): string {
  return [city.name, cityRegion(city, locale)].filter(Boolean).join(", ");
}
